import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// UI state only. Selection belongs to a report instance, not to its saved content.
const initialState = { selectedQuestionByReport: {} as Record<string, string | null> };
export const startupChecklistsSlice = createSlice({
  name: "startupChecklists",
  initialState,
  reducers: {
    selectStartupChecklistQuestion: (state, action: PayloadAction<{ reportId: string; questionId: string | null }>) => {
      state.selectedQuestionByReport[action.payload.reportId] = action.payload.questionId;
    },
  },
});
export const { selectStartupChecklistQuestion } = startupChecklistsSlice.actions;
